<div style="margin: 20px; width:100%">
  <div class="header accent p-24 " fxLayout="row" fxLayoutAlign="start center">
    <button mat-icon-button class="mr-16" [routerLink]="'/'+url">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <mat-tab-group animationDuration="2000ms" style="margin-top:10px;">
    <mat-tab>
      <ng-template mat-tab-label >
      <mat-icon  class="example-tab-icon" >bar_chart</mat-icon>
      {{'RESULTA-AUDITO.TIEM-RES-TAB' | translate}}
    </ng-template>
      <h1>{{'RESULTA-AUDITO.TIEM-RES-TITULO' | translate}}</h1> <br>
      <div fxLayout="column" fxLayoutAlign="center center" >
      <div class="" fxLayout="row">
        <h2>{{'RESULTA-AUDITO.RES-AGREGAR' | translate}}</h2>
        <button mat-fab color="primary" aria-label="agregaPreg" (click)="openCrearMuestra()">
        <mat-icon>add</mat-icon>
        </button>
        <!-- <button mat-fab color="primary" aria-label="agregaPreg" (click)="crearMuestrasMenor10Min()">
        <mat-icon>add</mat-icon>
        </button> -->
      </div>
      <div class="selectWidth" fxLayout="row" fxLayoutAlign="center center">
      <mat-form-field appearance="outline" class="select">
      <mat-label>{{'RESULTA-AUDITO.RES-SELECCIONAR' | translate}}</mat-label>
      <mat-select>
      <mat-option *ngFor="let muestra of muestras" [value]="muestra.productoId" (click)="getConsulta1(muestra._id); getMuestrasColaboradores(muestra._id);">{{muestra.nombre}}</mat-option>
      </mat-select>
      </mat-form-field>
      </div>
      </div>
      <br> <br>
      <div class="textoInicio" fxLayout="column" fxLayoutAlign="center center" *ngIf="!creacionGrafico">
        <p id="texto" *ngIf="!muestra">{{'RESULTA-AUDITO.RES-TEXTO1' | translate}}</p>
        <p id="texto" *ngIf="muestra">{{'RESULTA-AUDITO.RES-TEXTO2' | translate}}</p>
        </div>
      <div fxLayoutAlign="center center" class="graficaHorizontal">
        <ng-container *ngIf="muestra && creacionGrafico">
            <canvas baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [plugins]="barChartPlugins"
            [chartType]="barChartType"
            [colors]="ChartColors">
          </canvas>
        </ng-container>
      </div> <br>

      <h1 *ngIf="muestra && creacionGrafico">{{'RESULTA-AUDITO.TABLA.TITULO' | translate}}</h1> <br>
<div fxLayoutAlign="center center" *ngIf="muestra && creacionGrafico">
        <table mat-table [dataSource]="tablaColaboradores" class="mat-elevation-z8" >


  <ng-container matColumnDef="nombre">
    <th mat-header-cell *matHeaderCellDef> {{'RESULTA-AUDITO.TABLA.NOMBRE' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div *ngFor="let item of element.colaboradores">
      {{item.fullName}}
      </div></td>
  </ng-container>

  <ng-container matColumnDef="telefono">
    <th mat-header-cell *matHeaderCellDef> {{'RESULTA-AUDITO.TABLA.TELEFONO' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div *ngFor="let item of element.colaboradores">
      {{item.phone}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="celular">
    <th mat-header-cell *matHeaderCellDef> {{'RESULTA-AUDITO.TABLA.CELULAR' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div *ngFor="let item of element.colaboradores">
      {{item.cellphone}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef> {{'RESULTA-AUDITO.TABLA.CORREO' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div *ngFor="let item of element.colaboradores">
      {{item.email}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="comentario">
    <th mat-header-cell *matHeaderCellDef> {{'RESULTA-AUDITO.TABLA.COMENTARIO' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div *ngFor="let item of element.colaboradores">
        <mat-form-field appearance="outline">
        <textarea matInput required [(ngModel)]="item.comment_auditoria" rows="4" (blur)="editarComentarioAuditoria(item._id, item.comment_auditoria, $event)"></textarea>
        </mat-form-field>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>

  </mat-tab>
   <mat-tab >
     <ng-template mat-tab-label >
     <mat-icon  class="example-tab-icon" >pie_chart</mat-icon>
     {{'RESULTA-AUDITO.TIEM-RES-TAB' | translate}}
   </ng-template>
    <h1>{{'RESULTA-AUDITO.RES-CONT-TITULO' | translate}}</h1>
    <!-- <canvas baseChart
    [data]="pieChartData"
    [labels]="pieChartLabels"
    [chartType]="pieChartType"
    [options]="pieChartOptions"
    [colors]="pieChartColors"
    [legend]="pieChartLegend">
  </canvas> -->
</mat-tab>
<!--<mat-tab label="{{'RESULTA-AUDITO.RES-COMENT-TAB' | translate}}">
  <h1>{{'RESULTA-AUDITO.RES-COMENT-TITULO' | translate}}</h1>
  <canvas baseChart
  [datasets]="barChartDataVertical"
  [labels]="barChartLabelsVertical"
  [options]="barChartOptionsVertical"
  [chartType]="barChartTypeVertical"
  [colors]="ChartColorsVertical">
</canvas>
</mat-tab> -->
</mat-tab-group>
<!-- Create a div where the graph will take place -->


</div>
